import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Transfer } from 'src/app/app.models';
import { TransferService } from 'src/app/services/transfer.service';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';




@Component({
  selector: 'app-transfer-create',
  templateUrl: './transfer-create.component.html',
  styleUrls: ['./transfer-create.component.scss']
})
export class TransferCreateComponent implements OnInit, OnDestroy {

  transferSubscription: Subscription;

  transferCreated: boolean;

  public form!: UntypedFormGroup;


  constructor(public dialogRef: MatDialogRef<TransferCreateComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public fb: UntypedFormBuilder,
              private toastr: ToastrService,
              private transferService: TransferService,
              public appService: AppService) { }

  ngOnInit(): void {

    this.initProperty();

  }

  private initProperty() {

    this.form = this.fb.group({
      transfer_amount: ['', Validators.required],
    }); 

    this.transferCreated = false;

    // console.log(this.data);

  }

  public onSubmit() {

    // console.log(this.form.status);

    if(this.form.status != 'INVALID') { 

      if(this.form.value.transfer_amount > this.data.amount) {

        this.toastr.show(
          'Veuillez saisir un montant inférieur ou égal à '+this.data.amount,
          'Montant Incorrect',
          {
            timeOut: 4000,
            closeButton: true,
          } as IndividualConfig,
          'toast-' + 'error'
        )

      } else {

        if(this.form.value.transfer_amount < 500) {

          this.toastr.show(
            'Le montant saisi dois être supérieur ou égal à 500 XOF',
            'Montant Incorrect',
            {
              timeOut: 4000,
              closeButton: true,
            } as IndividualConfig,
            'toast-' + 'error'
          )

        } else {

          let transfer: Transfer = {
            'transfer_amount': this.form.value.transfer_amount,
            'transfer_type': this.data.key,
            'transfer_status': 'EN_ATTENTE',
            'user_id': this.data.idUser,
            'created_at':null
          }
  
          this.transferSubscription = this.transferService.create(transfer).subscribe((response: any) => {
            
            if(response.status) {
  
              this.dialogRef.close();
  
              this.toastr.show(
                'La demande de virements a été enregistré avec success',
                'Success Success',
                {
                  timeOut: 4000,
                  closeButton: true,
                } as IndividualConfig,
                'toast-' + 'success'
              )
  
            } else {
  
              this.dialogRef.close();
  
              this.toastr.show(
                response.message,
                'Erreur Erreur',
                {
                  timeOut: 4000,
                  closeButton: true,
                } as IndividualConfig,
                'toast-' + 'erreur'
              )
            }
           
          })

        }
        
      }
     
    }

  }

  ngOnDestroy(): void {
    
    if(this.transferCreated) {

      this.transferSubscription.unsubscribe();

    }
    
  }

}
